var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "79px",
    viewBox: "0 0 86 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3738243_award_education_learning_reward_school_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-WP-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-4.000000, -11.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "3738243_award_education_learning_reward_school_icon",
    transform: "translate(6.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 75,
    x2: 61,
    y2: 75,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,50 L41,50 C29.5283798,50 19.4437564,37.3875 16.2899897,19.0958333 L13,0 L69,0 L65.6976264,19.0958333 C62.5562436,37.3875 52.4716202,50 41,50 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,52 C37,52 37,69 23,69",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,52 C44,52 44,69 58,69",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1993174,9 L81.6660553,9 C81.6660553,9 85.5259744,29.271345 67,37",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8006826,9 L0.333944698,9 C0.333944698,9 -3.52597441,29.271345 15,37",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b42972066ed9ce258be638fb80669fbe.svg";
export { ForwardRef as ReactComponent };